import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ADMIN_CREDENTIALS from "./adminConfig";
import Header from "../components/Header";
const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = () => {
    if (
      email === ADMIN_CREDENTIALS.email &&
      password === ADMIN_CREDENTIALS.password
    ) {
      localStorage.setItem("isAdmin", "true");
      navigate("/admin-dashboard");
    } else {
      alert("Invalid Admin Credentials");
    }
  };

  return (
<>
<Header/>


    <div className="container py-5" style={{ maxWidth: "400px" }}>
      <h3 className="mb-4 text-center">Admin Login</h3>

      <input
        type="email"
        className="form-control mb-3"
        placeholder="Admin Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <input
        type="password"
        className="form-control mb-3"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button
        className="btn btn-warning w-100"
        onClick={handleLogin}
      >
        Login
      </button>
    </div>
 </> );
};

export default AdminLogin;
